// extracted by mini-css-extract-plugin
module.exports = {"Tooltip":"Tooltip_Tooltip__2jN97"};